import { render, staticRenderFns } from "./finish-approval-details.vue?vue&type=template&id=3e6320bc"
import script from "./finish-approval-details.vue?vue&type=script&lang=js"
export * from "./finish-approval-details.vue?vue&type=script&lang=js"
import style0 from "./finish-approval-details.vue?vue&type=style&index=0&id=3e6320bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports